<template>
  <el-dialog
    class="award-custom-dialog custom-dialog"
    :title="`${
      data && data.award_id && data.status === 'N'
        ? '首次归属操作'
        : '修改归属操作'
    }`"
    :visible.sync="visible"
    :before-close="handleBeforeClose"
    :close-on-click-modal="false"
    width="576px"
  >
    <div>
      <el-form
        ref="form"
        :model="info"
        v-loading="getDetailLoading"
        :rules="formRules"
        hide-required-asterisk
        label-width="70px"
        class="custom-award"
      >
        <div class="form__title mt-24">参与人信息</div>
        <div class="from_item__both flex-h flex-hw">
          <el-form-item
            label="手机号"
            prop="phone"
            class="from_item__height_none"
          >
            {{ otherInfo.phone }}
          </el-form-item>
          <el-form-item label="姓名" class="from_item__height_none">
            {{ otherInfo.user_name || "---" }}
          </el-form-item>
          <el-form-item label="在职状态" class="from_item__height_none">
            {{
              tableMng.getNameById("employ_status", otherInfo.employ_status) ||
              "---"
            }}
          </el-form-item>
          <el-form-item label="所属部门" class="from_item__height_none">
            <TextOverflow :limit="10" :text="otherInfo.department || '- -'" />
          </el-form-item>
        </div>
        <div class="form__title">期权激励计划信息</div>
        <el-form-item label="授予编号" class="from_item__height_none">
          {{ otherInfo.code || "---" }}
        </el-form-item>
        <div class="from_item__three flex-h flex-hw">
          <el-form-item label="出资方式" class="from_item__height_none">
            {{ tableMng.getNameById("buy_mode", otherInfo.buy_mode) || "---" }}
            <!-- <TextOverflow :limit="6" :text="planInfo.code || '- -'" /> -->
          </el-form-item>
          <el-form-item label="币种" class="from_item__height_none">
            {{ otherInfo.currency || "---" }}
          </el-form-item>
          <el-form-item label="认购参考价" class="from_item__height_none w-85">
            {{ otherInfo.price || "---" }}
          </el-form-item>
        </div>
        <div class="form__title">批次信息</div>
        <el-form-item label="批次" class="from_item__height_none">
          {{ info.seq }}
        </el-form-item>
        <el-form-item label="可归属数" class="from_item__height_none">
          {{ info.expect_count }}股
        </el-form-item>
        <div class="form__title">归属信息</div>
        <el-form-item class="w-100" label="归属股数" prop="actual_count">
          <el-input
            label=""
            v-model="info.actual_count"
            v-number-format="{ limit: 0, min: 1 }"
            placeholder="请输入归属股数"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item class="w-100" label="实际出资方式" prop="buy_mode">
          <el-select v-model="info.buy_mode" placeholder="请选择实际出资方式">
            <el-option
              v-for="item in tableMng.getTable('buy_mode')"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="w-100" label="实际认购价" prop="price">
          <el-input
            label=""
            v-model="info.price"
            placeholder="请输入实际认购价"
            v-number-format="{ limit: 4 }"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleBeforeClose">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import api from "@/api";
import dialogLife from "@/mixins/dialogLife";
import TextOverflow from "@/components/base/text-overflow";
import { deepClone, formatDecimal } from "@/utils/core";
const defaultInfo = {
  actual_count: "",
  price: "",
  id: "",
  buy_mode: "",
  status: "",
};

export default {
  mixins: [dialogLife],
  components: {
    TextOverflow,
  },
  computed: {},
  data() {
    return {
      infoBackup: deepClone(defaultInfo),
      info: deepClone(defaultInfo),
      otherInfo: {},
      formRules: {
        actual_count: [
          { required: true, message: "请输入归属股数", trigger: "blur" },
        ],
        price: [
          { required: true, message: "请输入实际认购价", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    ["info.buy_mode"](val) {
      if (!this.info.price && val === "2") this.info.price = "0";
    },
  },
  methods: {
    async getDetail() {
      if (!this.data) return;
      // console.log(this.data);
      this.getDetailLoading = true;
      let data = deepClone(this.data);
      this.otherInfo = data.otherInfo;
      if (data.status !== "Y") {
        data.actual_count = data.actual_count == 0 ? "" : data.actual_count;
        data.price = data.price == "0.0000" ? "" : data.price;
      }

      this.info = data;
      this.infoBackup = data;
      this.getDetailLoading = false;
    },
    async submitMethod() {
      const { id, buy_mode, price, actual_count, status } = this.info;
      if (status === "Y")
        await api.awarded.stockMatureAllotEdit({
          id,
          buy_mode,
          price: formatDecimal(price, 4),
          actual_count: formatDecimal(actual_count, 0),
        });
      else
        await api.awarded.stockMatureAllot({
          id,
          buy_mode,
          price: formatDecimal(price, 4),
          actual_count: formatDecimal(actual_count, 0),
        });
    },
    handleClose() {
      this.$refs.form.resetFields();
      this.info = deepClone(defaultInfo);
      this.infoBackup = deepClone(defaultInfo);
      this.$emit("onClose");
    },
  },
};
</script>

<style lang="scss" scoped>
.award-custom-dialog {
  .w-100 {
    width: 100%;
  }
  /deep/ .el-dialog__body {
    padding-top: 0px;
    .el-form {
      padding-top: 0px;
    }
  }
  .custom-award {
    .mt-24 {
      margin-top: 24px;
    }
    .form__title {
      font-size: 14px;
      color: $black;
      line-height: 22px;
      font-weight: 600;
      padding-bottom: 12px;
      padding-top: 12px;
    }
    .w-100 {
      /deep/ {
        .el-form-item__label {
          width: 100px !important;
        }
        .el-form-item__content {
          margin-left: 100px !important;
        }
      }
    }
    .w-85 {
      /deep/ {
        .el-form-item__label {
          width: 85px !important;
        }
        // .el-form-item__content {
        //   margin-left: 100px !important;
        // }
      }
    }
    .from_item__height_none {
      &.width-auto {
        width: auto !important;
      }
      /deep/ .el-form-item__label,
      /deep/ .el-form-item__content {
        line-height: 1;
      }
    }
    .from_item__both {
      /deep/.el-form-item {
        width: calc(50% - 16px);
        &:nth-child(2n) {
          margin-left: 32px;
        }
      }
    }
    .from_item__three {
      /deep/.el-form-item {
        width: calc(32.33% - 20px);
        &:nth-child(3n) {
          width: calc(38.33% - 20px);
        }
        &:nth-child(3n - 1) {
          width: calc(29.33% - 20px);
          margin-left: 30px;
          margin-right: 30px;
        }
      }
    }
  }
}
</style>
